import type { Filter, FilterOperator } from '@shared/types';
import {
  getValueDisplay,
  isArrayOperator as isArrayOperatorRule,
  OPERATORS,
  parseValueFromString,
} from './query-condition-row.domain';

export interface QueryConditionRowProps {
  condition: Filter;
  index: number;
  availableFields: string[];
  onChange: (index: number, condition: Filter) => void;
  onRemove: (index: number) => void;
}

export function useQueryConditionRow({
  condition,
  index,
  availableFields,
  onChange,
  onRemove,
}: QueryConditionRowProps) {
  const valueDisplay = getValueDisplay(condition.value);
  const isArrayOperator = isArrayOperatorRule(condition.operator);

  const handleFieldChange = (field: string) => {
    onChange(index, { ...condition, field });
  };

  const handleOperatorChange = (operator: FilterOperator) => {
    onChange(index, { ...condition, operator });
  };

  const handleValueChange = (value: string) => {
    const parsedValue = parseValueFromString(value);
    onChange(index, { ...condition, value: parsedValue });
  };

  const handleRemove = () => {
    onRemove(index);
  };

  return {
    condition,
    index,
    availableFields,
    valueDisplay,
    isArrayOperator,
    operators: OPERATORS,
    handleFieldChange,
    handleOperatorChange,
    handleValueChange,
    handleRemove,
  };
}
